import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { TrendingUp, Info } from 'lucide-react';
interface HeroBannerProps {
  name: string;
  avatar: string;
  weeklyImpact: number;
  completedActions?: number;
  weeklyGoal?: number;
  onShowCommunityImpact?: () => void;
}
export function HeroBanner({
  name,
  avatar,
  weeklyImpact,
  completedActions = 12,
  weeklyGoal = 15,
  onShowCommunityImpact
}: HeroBannerProps) {
  return <div className="relative w-full pt-20 pb-8 px-6 text-white overflow-hidden bg-green-600" data-id="element-58">
      {/* Pattern Overlay */}
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/wsCbUWp4TF3ni7DwEfb9qP/hand-drawn-turtle-shell-pattern_23-2150598661.jpg)'
    }} data-id="element-59" />

      {/* Content */}
      <div className="relative z-10 max-w-md mx-auto" data-id="element-60">
        {/* Centered Profile */}
        <div className="flex flex-col items-center mb-8" data-id="element-61">
          <Avatar className="h-32 w-32 border-4 border-white/30 mb-4 shadow-2xl" data-id="element-62">
            <AvatarImage src={avatar} data-id="element-63" />
            <AvatarFallback className="text-2xl" data-id="element-64">
              {name.charAt(0)}
            </AvatarFallback>
          </Avatar>
          <h2 className="text-2xl font-normal mb-1" data-id="element-65">Ciao, {name}! 👋</h2>
          <p className="text-sm text-white/90" data-id="element-66">
            Pronto/a a fare la differenza oggi?
          </p>
        </div>

        {/* Weekly Impact */}
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-5 border border-white/20 shadow" data-id="element-67">
          <div className="flex items-center justify-between mb-3" data-id="element-68">
            <div className="flex items-center gap-2" data-id="element-69">
              <TrendingUp className="h-5 w-5 text-white" strokeWidth={2} data-id="element-70" />
              <h3 className="text-base font-normal text-white" data-id="element-71">
                Impatto settimanale
              </h3>
            </div>
            <span className="text-2xl font-normal text-white" data-id="element-72">
              {weeklyImpact}%
            </span>
          </div>
          <div className="w-full bg-white/20 rounded-full h-2 overflow-hidden" data-id="element-73">
            <div className="bg-white h-full rounded-full transition-all duration-500" style={{
            width: `${weeklyImpact}%`
          }} data-id="element-74" />
          </div>
          {/* Info tooltip line */}
          <p className="text-xs text-white/75 mt-2 flex items-center gap-1" data-id="element-75">
            <Info className="h-3 w-3 flex-shrink-0" strokeWidth={2} data-id="element-76" />
            Basato su {completedActions} azioni completate su {weeklyGoal}{' '}
            obiettivo settimanale
          </p>
          <div className="flex items-center justify-between mt-2" data-id="element-77">
            <p className="text-xs text-white/90" data-id="element-78">
              {weeklyImpact > 70 ? '🎉 Sopra la media della community!' : weeklyImpact > 40 ? '✨ Continua così!' : '💪 Puoi fare di più!'}
            </p>
            {onShowCommunityImpact && <button onClick={onShowCommunityImpact} className="flex items-center gap-1 text-xs text-white/90 hover:text-white transition-colors bg-white/10 hover:bg-white/20 px-3 py-1 rounded-full" data-id="element-79">
                <span data-id="element-80">Dettagli</span>
                <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-81">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" data-id="element-82" />
                </svg>
              </button>}
          </div>
        </div>
      </div>
    </div>;
}